<script>

    import _                        from 'lodash'
    import { getContext, onMount }  from 'svelte'
    import { fade }                 from 'svelte/transition'
    import * as api                 from '../../shared/api.js'
    import Issues                   from '../../shared/Issues.svelte'

    export let domain
    export let activity
    export let issues = []
  
    const ctx = getContext('activities')
  
    let profiles = []
    let loading  = false
    let working  = {}
    let errors   = {}

    $: selected = activity.profiles || []

    onMount( () => {
        loading = true
        api
          .get(`/profiles/domain/${domain.id}`)
          .then(api.toJsonIf200)
          .then(json => {
              loading  = false
              profiles = json
          }).catch(err => {
              console.log(err)
              loading  = false
          })
    })

    function update(profile) {
      return () => {
        const add = !selected.find(id => id == profile.id)
        const url = `/inventory/domain/${domain.id}/${add ? 'add' : 'remove'}/profile` 

        working[profile.id] = true
        errors[profile.id]  = false
        api
          .post(url, { activity: activity.id, profile: profile.id })
          .then(api.delay(250))
          .then(api.toJsonIf200)
          .then(json => {
            working[profile.id] = false
            errors[profile.id] = false
            ctx.setInventory(json)
          })
          .catch(err => {
            console.log(err)
            working[profile.id] = false
            errors[profile.id]  = add ? "erro adicionando" : "erro removendo"
            setTimeout(() => { errors[profile.id] = false }, 2000)
          })
      }
    }    
    
</script>

<h3 class="ui header">Perfis</h3>

{#if issues.length > 0}
  <div class="ui basic segment">
      <Issues {issues}>
          Problemas:
      </Issues>
  </div>
{/if}

{#if loading || profiles.length > 0}
  <div class="ui segments" class:loading>
    {#each profiles as profile (profile.id)}
      <div class="ui left aligned segment item">
          <div class="ui toggle big checkbox" class:disabled={working[profile.id]}>
              <input type="checkbox" value={profile.id} bind:group={selected} on:change={update(profile)}>
              <label>
                <h4 class="ui header">{profile.name}</h4>
                <div class="description">{profile.description || ''}</div>
              </label>
          </div>
          {#if working[profile.id]}
            <div transition:fade class="bottom-right">
              <i class="notched circle loading icon"></i>
            </div>
          {/if}

          {#if errors[profile.id]}
            <div transition:fade class="bottom-right">
              <div class="ui small red label">{errors[profile.id]}</div>
            </div>
          {/if}
      </div>
    {/each}
  </div>
{/if}

<style>
  h3.ui.header {
      margin-top: 3em;
  }
  .description {
    color: #ccc;
    font-size: 1em;
  }

  .item {
    position: relative;

  }

  .bottom-right {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }

  .ui.checkbox.disabled {
    pointer-events: none;
  }

</style>